import { EnvironmentProviders } from '@angular/core';

import { provideOnboardingJourneys } from './engine/journey-registry';
import {
  APPROVER_WELCOME_JOURNEY,
  ORDER_WELCOME_JOURNEY,
  REQUESTER_WELCOME_JOURNEY,
} from './journeys/profile-trails.journey';
import { CARRIER_FIRST_BID_JOURNEY } from './journeys/carrier-first-bid.journey';
import { SHIPPER_FIRST_SPOT_JOURNEY } from './journeys/shipper-first-spot.journey';

/** Jornadas disponíveis na plataforma (o backend decide quais valem para cada usuário, pelo perfil). */
export function provideOnboarding(): EnvironmentProviders {
  return provideOnboardingJourneys(
    SHIPPER_FIRST_SPOT_JOURNEY,
    REQUESTER_WELCOME_JOURNEY,
    APPROVER_WELCOME_JOURNEY,
    ORDER_WELCOME_JOURNEY,
    CARRIER_FIRST_BID_JOURNEY
  );
}
